
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:AddressDefault:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      Flits('.flits-address-card-action').removeClass('flits-disabled');
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  Flits(document).on('Flits:AddressSave:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  Flits(document).on('click','.flits-order-quantity-custom .flits-quantity-btn[data-flits-qty-btn="minus"]',function(event){
    var th = Flits(this).closest('.flits-order-quantity-custom').find('input[name="product_quantity_input"]');
    if (th.val() > 1) th.val(+th.val() - 1);
  });
  Flits(document).on('click','.flits-order-quantity-custom .flits-quantity-btn[data-flits-qty-btn="plus"]',function(event){
    var th = Flits(this).closest('.flits-order-quantity-custom').find('input[name="product_quantity_input"]');
    th.val(+th.val() + 1);
  });
  Flits(document).on('click','.flits-custom-reorder',function(event){
  	var orderId = Flits(this).attr('data-target');
    Flits('.custom-reorder-popup[rel="'+orderId+'"]').addClass('active');
    Flits('.custom-reorder-popup[rel="'+orderId+'"] .custom-reorder-add-to-cart').prop('disabled', false);
  });
  Flits(document).on('click','.custom-reorder-popup-close',function(event){
    var orderId = Flits(this).attr('data-target');
  	Flits('.custom-reorder-popup[rel="'+orderId+'"]').removeClass('active');
    Flits('.custom-reorder-popup[rel="'+orderId+'"] .custom-reorder-popup-body .custom-reorder-item-row').removeAttr('style');
  });
  function customAddToCart(params){
    flitsSnackbar.show({ text: Flits.t("Flits.locals.cart_page.adding_items_to_cart", "Adding items to cart..."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default flits-alert-custom", duration: !1 });
    Flits.ajax({ type: "POST", url: "/cart/add.js", data: params, dataType: "json" })
    .done(function (resp) {
      setTimeout(function(){
        Flits.flitsSnackbarHide();
        Flits.getJSON('/cart.js', function(cart) {
          Flits(".header__cart-toggle .header__cart-count").text(cart.item_count);
        });
        Flits("#mini-cart").load(document.URL + " #mini-cart > *");
      }, 600);
      setTimeout(function(){
        Flits('.custom-reorder-popup.active .custom-reorder-popup-close').trigger('click');
      }, 4500);
      setTimeout(function(){
        Flits('.header__action-item--cart .header__cart-toggle')[0].click();
      }, 4700);
    })
    .fail(function (resp) {
      flitsSnackbar.show({ text: resp.responseJSON.description, pos: "top-center", showAction: !1, customClass: "flits-alert-error" });
      Flits('.custom-reorder-popup.active .custom-reorder-popup-close').trigger('click');
    })
    .always(function () {});
    return false;
  }
  Flits(document).on('click','.custom-reorder-add-to-cart',function(event){
    Flits(this).prop('disabled', true);
    Flits(this).append('<div class="flits-custom-loader"></div>');
  	var orderId = Flits(this).attr('data-target');
    var orderItems = window.flitsOrder[orderId];
    var params = {};
    params["items"] = [];
    var orderDiv = Flits(this).parents('.custom-reorder-popup-inner').find('.custom-reorder-item-row:visible');
    var cartContainDonation = 0;
    var cartContainNormal = 0;
    var reorderItems = {};
    reorderItems["items"] = [];
    Flits(orderDiv).each(function(index, ele){
      var orderItemQuantity = Flits(ele).find('.item-quantity input[name="product_quantity_input"]').val();
      var orderItemId = Flits(ele).attr('data-variant-id');
      var orderItemHandle = Flits(ele).attr('data-flits-handle');
      reorderItems["items"].push({ id: orderItemId, quantity: orderItemQuantity, handle: orderItemHandle });
    });
    Flits.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          if(cart.item_count >= 1){
            Flits(cart.items).each(function(index, ele){
              if(ele.handle.indexOf('donation-to') !== -1){
                cartContainDonation = 1;
              }
              else{
                cartContainNormal = 1;
              }
            });
          }
          //Flits.dispatchEvent("Flits:CartItem:Loaded", { cartContainDonation: cartContainDonation, cartContainNormal: cartContainNormal }); 
        }
    });
    setTimeout(function(){
      Flits('.custom-reorder-add-to-cart .flits-custom-loader').remove();
      if(cartContainDonation === 1){
        Flits(reorderItems["items"]).each(function(index, ele){
          var isLastElement = index == reorderItems["items"].length - 1;
          if(ele.handle.indexOf('donation-to') !== -1){
            params["items"].push({ id: ele.id, quantity: ele.quantity });
            if (isLastElement) {
              if(params["items"].length >= 1){
              	customAddToCart(params);
              }
            }
          }
          else{
            flitsSnackbar.show({ text: "Normal items cannot be combined with DONATION items. Please check-out items separately.", pos: "top-center", showAction: !1, customClass: "flits-alert-default flits-alert-custom", duration: 3500 });
            return false;
          }
        });
      }
      else{
        if(cartContainNormal === 1){
          Flits(reorderItems["items"]).each(function(index, ele){
            var isLastElement = index == reorderItems["items"].length - 1;
            if(ele.handle.indexOf('donation-to') !== -1){
              flitsSnackbar.show({ text: "Normal items cannot be combined with DONATION items. Please check-out items separately.", pos: "top-center", showAction: !1, customClass: "flits-alert-default flits-alert-custom", duration: 3500 });
              return false;
            }
            else{
              params["items"].push({ id: ele.id, quantity: ele.quantity });
              if (isLastElement) {
                if(params["items"].length >= 1){
                  customAddToCart(params);
                }
              }
            }
          });
        }
        else{
          Flits(reorderItems["items"]).each(function(index, ele){
          	var isLastElement = index == reorderItems["items"].length - 1;
            params["items"].push({ id: ele.id, quantity: ele.quantity });
            if (isLastElement) {
              if(params["items"].length >= 1){
              	customAddToCart(params);
              }
            }
          });
        }
      }
    }, 2500);
  });
  Flits(document).on('click','.custom-reorder-popup .item-delete',function(event){
  	Flits(this).parents('.custom-reorder-item-row').hide();
    setTimeout(function(){
      if(Flits('.custom-reorder-popup.active .custom-reorder-popup-body .custom-reorder-item-row:visible').length == 0){
      	Flits('.custom-reorder-popup.active .custom-reorder-popup-close').trigger('click');
      }
    },500);
  });
}(Flits));
